import {
    UPDATE_CALENDAR_RULES,
    UPDATE_CALENDAR_RULES_SUCCESS
} from './constants';

/**
 *
 * @param id
 * @param value
 * @returns {{id: *, type: string, value: *}}
 */
const updateCalendarRules = ( id, value ) => ( {
    type: UPDATE_CALENDAR_RULES,
    id,
    value
} );
/**
 *
 * @param rules
 * @returns {{rules: *, type: string}}
 */
const updateCalendarRulesSuccess = rules => ( {
    type: UPDATE_CALENDAR_RULES_SUCCESS,
    rules
} );

export {
    updateCalendarRules,
    updateCalendarRulesSuccess
};